import { useEffect, useMemo, useState } from "react";
import { arrayMove } from "@dnd-kit/sortable";
import { byPlanOrder, nextSortOrder } from "./planItems";
import {
  subscribePlanItems, addPlanItem, updatePlanItem, deletePlanItem, writePlanOrder,
} from "./planItemService";

// One kind's items (dreams), live, in the user's order, with the writes that change them.
export function usePlanItems(uid, kind) {
  const [raw, setRaw] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!uid) return undefined;
    setRaw(null);
    setError(null);
    return subscribePlanItems(uid, kind, setRaw, setError);
  }, [uid, kind]);

  const items = useMemo(() => (raw ? [...raw].sort(byPlanOrder) : []), [raw]);

  return {
    items,
    loading: raw === null && !error,
    error,
    add: (fields) => addPlanItem(uid, kind, fields, nextSortOrder(items)),
    update: (id, fields) => updatePlanItem(uid, kind, id, fields),
    remove: (id) => deletePlanItem(uid, kind, id),
    move: (activeId, overId) => {
      const from = items.findIndex(it => it.id === activeId);
      const to = items.findIndex(it => it.id === overId);
      if (from < 0 || to < 0 || from === to) return Promise.resolve();
      return writePlanOrder(uid, kind, arrayMove(items, from, to).map(it => it.id), items);
    },
  };
}
